import { createContext, MutableRefObject, useContext } from 'react';

export type MapEntityDetailsLayoutContextValue = {
  scrollElementRef: MutableRefObject<Element | undefined> | null;
  // Height reported by `Header` once it becomes sticky.
  headerContentHeight: number;
  isHeaderFixed: boolean;
  onHeaderStickyChange: (isFixed: boolean) => void;
  onHeaderContentHeightChange: (contentHeight: number) => void;
};

export const MapEntityDetailsLayoutContext =
  createContext<MapEntityDetailsLayoutContextValue | null>(null);

export const useMapEntityDetailsLayoutContext =
  (): MapEntityDetailsLayoutContextValue => {
    const context = useContext(MapEntityDetailsLayoutContext);
    if (!context) {
      throw new Error(
        'MapEntityDetailsLayout subcomponents must be used within <MapEntityDetailsLayout.Root>',
      );
    }
    return context;
  };
